import React from "react";
import { IItem } from "../types";
import {
  Draggable,
  DraggableProvided,
  DraggableStateSnapshot,
  Droppable,
  DroppableProvided,
  DroppableStateSnapshot,
} from "@hello-pangea/dnd";
import Item from "./Item";

interface ItemListProps {
  items: IItem[];
  title: string;
  id: string;
}

const ItemList = (props: ItemListProps) => {
  const { items, title, id } = props;

  return (
    <Droppable droppableId={id} type={"ITEM"}>
      {(
        dropProvided: DroppableProvided,
        dropSnapshot: DroppableStateSnapshot
      ) => (
        <div
          className="h-full flex flex-col select-none w-64 overflow-y-auto"
          {...dropProvided.droppableProps}
        >
          <div className="h-full px-2" ref={dropProvided.innerRef}>
            {items &&
              items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(
                    dragProvided: DraggableProvided,
                    dragSnapshot: DraggableStateSnapshot
                  ) => (
                    <Item
                      key={item.id}
                      item={item}
                      provided={dragProvided}
                      columnId={id}
                      index={index}
                    />
                  )}
                </Draggable>
              ))}
            {dropProvided.placeholder}
          </div>
        </div>
      )}
    </Droppable>
  );
};

export default ItemList;
